<template>
<header class="admin-site-header">
    <div class="full-container">
      <div class="custom-row">
        <button id="leftMenuSlideTop" class="mobile-nav-icon"><span></span></button>
        <div class="logo">
          <router-link to="/authority/dashboard">
            <img src="@/assets/images/logo.svg" alt="Logo">
          </router-link>
        </div>
        <div class="header-right">
          <div class="login-user-info">
            <a href="javascript:void(0)" id="userHdrInfoLink">
              <i class="small-user-img">
                <img :src="imageUrl" alt="User Avatar">
              </i>
              <span>{{firstname}}</span>
            </a>
            <div class="login-user-info-dropdown" id="userHdrDropdown">
              <div class="login-user-info-dropdown-in">
                <router-link class="my-profile-icon" id="userHdrPfileLink" :class="{ active: $route.path === '/authority/profile' }" to="/authority/profile">{{ constants['MY_PROFILE_MENU'] }}</router-link>
                <router-link class="edit-profile-icon" id="userHdrEditPfileLink" :class="{ active: $route.path === '/authority/edit-profile' }" to="/authority/edit-profile">{{ constants['EDIT_PROFILE_MENU'] }}</router-link>
                <router-link class="change-password-icon" id="userHdrChPwtLink" :class="{ active: $route.path === '/authority/change-password' }" to="/authority/change-password">{{ constants['CHANGE_PASSWORD_MENU'] }}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  </template>
<script lang="ts">
import constants from '@/utils/en-US-Admin.json';
import { defineComponent } from 'vue';
import { API_BASE_URL } from '@/config/api.config';
import { environment } from '@/config/environment';

export default defineComponent({
  name: "adminHeader",
  data() {
    const profileImage = localStorage.getItem('profile_image');  
    const baseUrl = `${API_BASE_URL}`;
    return {
      constants,
      profile_image: profileImage ? `${baseUrl}${profileImage}` : '',
      firstname: localStorage.getItem('firstname'),
    }
  },
  computed: {
    imageUrl(): string {
      return this.getCdnImageAddress(this.profile_image, `w_76,h_37/`) || require('@/assets/images/img_avatar.png');
    },
  },
  methods: {
    getCdnImageAddress(src: string, size: string): string {
        if (!src) return '';
        let cdnUrl: string = environment.imageCdn.getHost;
        cdnUrl = cdnUrl.concat(size);
        return cdnUrl + encodeURIComponent(src);
    },
  }

})
</script>